export default "__VITE_ASSET__wGLVkgAs__"